import { Eye, EyeSlash } from "iconsax-react";
import { useState } from "react";

import Button from "./Button";
import type { InputProps } from "./Input";
import Input from "./Input";

export type AuthInputProps = Omit<
  InputProps,
  "size" | "labelPlacement" | "classNames" | "label" | "ref"
> & {
  readonly label: string;
  readonly hiddable?: boolean;
};

export default function AuthInput({
  className,
  label,
  placeholder,
  isInvalid,
  hiddable,
  ...props
}: AuthInputProps) {
  const [isVisible, setIsVisible] = useState(false);

  const hiddableProps: InputProps = {
    type: isVisible ? "text" : "password",
    endContent: (
      <Button
        variant="ghost"
        size="unsized"
        className="focus:outline-none"
        onPress={() => setIsVisible(!isVisible)}
      >
        {isVisible ? (
          <Eye className="stroke-text-primary pointer-events-none" size={16} />
        ) : (
          <EyeSlash
            className="stroke-text-primary pointer-events-none"
            size={16}
          />
        )}
      </Button>
    ),
  };

  return (
    <Input
      variant="borderless"
      color="secondary"
      size="md"
      className={className}
      {...props}
      label={label}
      placeholder={placeholder ?? label}
      isInvalid={isInvalid ?? props.errorMessage !== undefined}
      {...(hiddable ? hiddableProps : {})}
    />
  );
}
